var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import de from "vee-validate/dist/locale/de.json";
import { getUrl, Langs, urls } from "./urls";
var DE = Langs.de;
export var de_mad = {
    banner: "Aufgrund einer laufenden Reorganisation innerhalb unserer Institution ist es uns vorübergehend nicht möglich, Ihre Suchanfragen zu bearbeiten oder unsere Sammlungen zur Verfügung zu stellen (mit Ausnahme der derzeit aktiven Partnerschaften)<br><br>Wir danken für Ihr Verständnis und werden Sie informieren, sobald unsere Dienstleistungen wieder zur Verfügung stehen.",
    // "<br>Vielen Dank für Ihr Verständnis.",
    generic: {
        country: 'Land',
        siteInstitutionel: 'Institutionelle Website',
        title: "Verwaltung von Anträgen",
        titleTicket: 'Meine Anfragen',
        makeTicket: 'Anfrage stellen',
        goToForms: 'Startseite',
        goToFormList: 'Alle Formulare',
        myProfile: 'Profil',
        modifyProfile: 'Mein Profil bearbeiten',
        homepage: 'Home',
        noResult: 'Keine Ergebnisse',
        visibility: 'Anzeigen',
        removeFilter: 'Filter entfernen',
        show: 'Anzeige:',
        elements: 'Elemente',
        informationLine1: 'Anzeige von Elementen',
        informationLine2: 'bis',
        informationLine3: 'von',
        informationLine4: 'Elementen',
        informationLine5: '(gefiltert aus',
        informationLine6: 'Elementen insgesamt)',
        tableTitle: 'Titel',
        tableCategory: 'Art der Anfrage',
        tableGroup: 'Gruppe',
        tableStatus: 'Status',
        tableAction: 'Anfrage ansehen',
        showTicket: 'Anfrage',
        showTicketLabel1: 'Titel : ',
        showTicketLabel2: 'Art : ',
        showClose: 'Diese Anfrage wurde geschlossen.',
        showNotBelong: 'Sie sind nicht berechtigt, diese Anfrage anzuzeigen.',
        messageBy: 'Von',
        messageTo: 'an',
        editorSend: 'Antwort senden',
        editorSendPrivate: 'Interne Nachricht',
        editorSendFiles: 'Ausgewählte Dateien senden',
        createTitle: 'Eine Anfrage stellen',
        notifications: 'Benachrichtigung | Benachrichtigungen',
        inscription: 'Registrieren',
        connexion: 'Login',
        connexionAdmin: 'Login CS',
        username: 'Benutzername',
        email: 'E-Mail',
        password: 'Passwort',
        csUser: 'CS User',
        passwordConfirm: 'Passwort bestätigen',
        remember: 'Anmeldedaten speichern',
        connect: 'Anmelden',
        passwordForgot: 'Passwort vergessen?',
        register: 'Neues Konto erstellen',
        emailResetPassword: 'Passwort zurücksetzen',
        emailAddress: 'E-Mail-Adresse',
        emailSend: 'Senden',
        resetConfirmPassword: 'Passwort bestätigen',
        registerUserTitle: 'Nutzer:in erstellen',
        registerTitle: 'Registrieren',
        editCustomerTitle: 'Kunde bearbeiten',
        registerCustomerTitle: 'Kunde registrieren',
        registerFirstName: 'Vorname',
        registerLastName: 'Nachname',
        phone: 'Telefon',
        phonecode: 'Vorwahl',
        statusFiaf: 'FIAF-Status',
        fiaf: 'FIAF-Mitglied',
        deliveryAddress: 'Lieferadresse',
        billingAddress: 'Rechnungsadresse',
        sameAddress: 'Gleich wie Lieferadresse',
        differentAddress: 'Andere Rechnungsadresse',
        city: 'Ort',
        streetName: 'Strasse',
        streetNumber: 'Nr.',
        zipCode: 'PLZ',
        companyName: 'Firmenname',
        registerSend: 'Bestätigen',
        verifyMail: 'Bestätigen Sie Ihre E-Mail-Adresse',
        verifyNewLink: 'Wir haben Ihnen einen Bestätigungslink geschickt.',
        verifyText: 'Bevor Sie fortfahren, prüfen Sie bitte Ihren Posteingang und klicken Sie in der erhaltenen Mail auf den Link. Falls Sie kein E-Mail erhalten haben:',
        verifyClick: 'Klicken Sie hier, um einen neuen Link anzufordern',
        back: 'Zurück',
        close: 'Schliessen',
        fillFields: 'Füllen Sie bitte die Felder aus',
        infos: 'Informationen',
        selectOption: 'Option auswählen',
        dateTimeFormat: 'de',
        dateLabels: {
            labelPrevDecade: 'Vorheriges Jahrzehnt',
            labelPrevYear: 'Vorheriges Jahr',
            labelPrevMonth: 'Vorheriger Monat',
            labelCurrentMonth: 'Aktueller Monat',
            labelNextMonth: 'Nächster Monat',
            labelNextYear: 'Nächstes Jahr',
            labelNextDecade: 'Nächstes Jahrzehnt',
            labelToday: 'Heute',
            labelSelected: 'Gewähltes Datum',
            labelNoDateSelected: 'Kein Datum gewählt',
            labelCalendar: 'Kalender',
            labelNav: 'Navigation im Kalender',
            labelHelp: 'Nutzen Sie die Pfeiltasten, um im Kalender zu navigieren'
        },
        timeLabels: {
            labelHours: 'Stunden',
            labelMinutes: 'Minuten',
            labelSeconds: 'Sekunden',
            labelIncrement: 'Inkrementieren',
            labelDecrement: 'Dekrementieren',
            labelSelected: 'Gewählte Stunde',
            labelNoTimeSelected: 'Keine Stunde gewählt',
            labelCloseButton: 'Schliessen'
        },
        filePicker: {
            label: 'Datei anhängen',
            button: 'Datei(en) anhängen',
            placeholder: 'Keine Datei ausgewählt',
            text1: "Sie können pro Nachricht maximal 10 Dateien mit insgesamt höchstens 25 MB versenden. Folgende Dateiformate werden unterstützt: doc, docx, xls, xlsx, pdf, txt, rtf, odt, ods, jpeg, jpg, png, zip.",
            sentFileListText: 'Gesendete Dateien:',
            tooBig: "Die Dateigröße von 25 MB wurde überschritten",
            specialCharacterWarning: "Bitte entfernen Sie alle Sonderzeichen (z. B. Apostroph (\"Vente d\'images.pdf\" umbenannt in \"Vente d_images.pdf\")) aus den Dateinamen und versuchen Sie es erneut",
        },
        billingDetails: {
            text1: "Rechnungsadresse",
            alttext1: "Kontaktdaten",
            text2: 'Gesellschaft / Anstalt / Firma / Privat *',
            text3: 'Strasse *',
            text4: 'Hausnummer *',
            text5: 'Postleitzahl *',
            text6: 'Ort *',
            text7: 'Land *',
            text8: 'Kontaktperson',
            text9: 'Vorname *',
            text10: 'Nachname *',
            text11: 'Vorwahl *',
            text12: 'Telefonnummer *',
            text13: 'E-Mail-Adresse *',
        },
        shippingDetails: {
            text1: "Versandadresse",
            alttext1: "Aktueller Standort des Bestands",
            text2: 'Gesellschaft / Anstalt / Firma / Privat *',
            text3: 'Strasse *',
            text4: 'Hausnummer *',
            text5: 'Postleitzahl *',
            text6: 'Ort *',
            text7: 'Land *',
            text8: 'Kontaktperson',
            alttext8: 'Kontaktperson - Logistikmanager',
            text9: 'Vorname *',
            text10: 'Nachname *',
            text11: 'Vorwahl *',
            text12: 'Telefonnummer *',
            text13: 'E-Mail-Adresse *',
        },
        searchedFilm: {
            text1: 'Gewünschter Film',
            text2: 'Vorname Regisseur:in',
            text3: 'Name Regisseur:in',
            text4: 'Originaltitel / deutscher Titel *',
            text5: 'Nachdem wir Ihre Anfrage bearbeitet haben, informieren wir Sie darüber, ob Material zur Verfügung steht und welche Möglichkeiten zur Visionierung Sie haben. Sie können dann gegebenenfalls eine Visionierung mit uns vereinbaren.',
            text6: 'Produktionsjahr',
            text7: 'Anzahl gesuchter Filme',
        },
    },
    notification: {
        action: 'Zum Ticket: ',
        contributor: "Ihnen wurde die Rolle des Beobachter (fr: intervenant) zugewiesen",
        responsible: "Ihnen wurde die Rolle des Verantwortlichen (fr: responsable) zugewiesen",
        message: 'Sie haben eine neue Nachricht.',
    },
    requests: {
        text1: 'Was ist Ihr Projekt?',
        text2: 'Die Cinémathèque suisse sammelt, bewahrt, erforscht und erschliesst das Schweizer und internationale Filmerbe. Als nationales Kompetenzzentrum stellt die Institution der Öffentlichkeit, Privatpersonen, Forschenden und Fachleuten verschiedene Ressourcen zur Verfügung. Weiter unten finden Sie Informationen zu den vorhandenen Ressourcen und erfahren, wie Sie darauf zugreifen können.',
        text3: 'Die Cinémathèque suisse beantwortet keine allgemeinen Fragen zur Filmgeschichte.',
        menu1: 'Auf die Sammlungen zugreifen',
        menu2: 'Hinterlegtes Material aus dem Bestand nehmen',
        menu3: 'Eine Filmvorführung organisieren',
        menu4: 'Die Cinémathèque suisse entdecken',
        menu5: 'Material hinterlegen oder abliefern'
    },
    requestsAccessCollection: {
        menu1: 'Filmsammlungen',
        menu2: 'Bibliothek',
        menu3: 'Archivbestände und Dokumentationsdossiers',
        menu4: 'Bildarchiv und museale Sammlungen',
        menu5: 'Informationen zu den Sammlungen',
    },
    requestsRequestMaterial: {
        menu1: 'Zugang zu hinterlegten Elementen',
    },
    requestsOrganizeProjection: {
        menu1: 'Film aus unseren Sammlungen zeigen',
        menu2: 'Promotionsmaterial erhalten',
        menu3: 'Kinosaal der Cinémathèque suisse mieten',
    },
    requestsSubmitMaterial: {
        menu1: 'Schenkungen und Hinterlegungen',
        menu2: 'Hinterlegung von Filmen mit Förderung des BAK oder von anderen regionalen Fonds',
    },
    requestsAccessCollection1: {
        text1: 'Die Cinémathèque suisse bewahrt in ihren Filmsammlungen Spielfilme, Dokumentarfilme, Werbe- und Auftragsfilme, Familienfilme und Amateurfilme auf. Ausserdem sind alle Ausgaben der <b>Schweizer Filmwochenschau</b> bei der Cinémathèque suisse hinterlegt. Die Institution kann deren Nutzung genehmigen und Material zur Verfügung stellen. Der gesamte Bestand der Schweizer Filmwochenschau kann kostenlos auf der Online-Plattform Memobase angesehen werden. Seit 2012 erwirbt die Cinémathèque suisse für einen kleinen Teil der Filme in ihren Sammlungen die Vertriebsrechte für Schweizer Kinos. Die Liste dieser Filme ist als <b>Vertriebskatalog</b> auf unserer Website frei zugänglich.',
        text2: "Der Gesamtkatalog der <b>Filmsammlungen</b> ist f\u00FCr die \u00D6ffentlichkeit nicht zug\u00E4nglich. Die Cin\u00E9math\u00E8que suisse kann jedoch auf spezifische Visionierungsanfragen eingehen oder Elemente aus ihren Sammlungen gem\u00E4ss den <a href=\"".concat(getUrl(urls.docs.d01, DE), "\" target=\"_blank\">\uD83D\uDDCEBestimmungen und Tarifen f\u00FCr die Nutzung von Filmkopien</a> bereitstellen. Bei der Bearbeitung der Anfragen wird die Art und der Zustand des jeweiligen Materials ber\u00FCcksichtigt. Werke, die im Handel erh\u00E4ltlich sind (z. B. als DVD, Blu-ray oder VOD), werden nicht f\u00FCr die Einsichtnahme bereitgestellt."),
        link1: '<b>Schweizer Filmwochenschau</b><br><a href="https://memobase.ch/fr/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
        link2: '<b>Vertriebskatalog</b><br><a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">cinematheque.ch/filmvertrieb</a>',
        menu1: {
            title: 'Visionierungsanfrage',
            text1: 'Forschende, Studierende und Personen mit einer Hinterlegung bei der Cinémathèque suisse können digitalisierte oder digital entstandene Elemente aus den Filmsammlungen im Lesesaal des Forschungs- und Archivierungszentrum in Penthaz oder in bestimmten Fällen auch per Fernzugriff anschauen. ',
            text2: '<b>Für eine Visionierung vor Ort müssen Sie sich vorgängig anmelden. Bitte stellen Sie dazu eine Visionierungsanfrage.</b>',
            text3: "Unter bestimmten Bedingungen k\u00F6nnen fotochemische Elemente aus den Sammlungen vor Ort gesichtet werden. Da dies jedoch vom Zustand und der Art des Materials sowie von der Verf\u00FCgbarkeit einer Fachperson der Cin\u00E9math\u00E8que suisse f\u00FCr die Begleitung der Sichtung abh\u00E4ngt, m\u00FCssen entsprechende Anfragen mindestens 15 Tage im Voraus gestellt werden. Informationen zu den Tarifen finden Sie im Dokument <a href=\"".concat(getUrl(urls.docs.d02, DE), "\" target=\"_blank\">\uD83D\uDDCETarife f\u00FCr die Einsichtnahme vor Ort</a>."),
            text4: 'Nach Möglichkeit können bestimmte digitalisierte Dokumente online über einen sicheren Link gesichtet werden.',
            button1: 'Visionierungsanfrage',
        },
        menu2: 'Suche und Vermietung von Projektionskopien',
        menu3: {
            title: 'Bestellung von Filmauszügen',
            text1: 'Die Cinémathèque suisse stellt Auszüge aus Filmen zur Verfügung. Der Verkauf von Auszügen <b>beschränkt sich auf bestimmte Filme aus ihren Sammlungen</b>: digitale oder digitalisierte Filme sowie auf die Sammlung der Schweizer Filmwochenschau.',
            text2: 'Die Cinémathèque suisse <b>digitalisiert keine Filme auf Anfrage</b>. Die Digitalisierung von Filmen erfolgt nach einem Plan, der der internen Politik entspricht. Dabei werden zeitliche Vorgaben für die Erhaltung berücksichtigt und sichergestellt, dass die Digitalisierungen ein möglichst breites Spektrum der Filmtätigkeit in der Schweiz abbilden.',
            text3: "Die Sammlung der digitalisierten Filme ist nicht \u00F6ffentlich zug\u00E4nglich \u2013 mit Ausnahme der Schweizer Filmwochenschau und der Filme aus dem Vertriebskatalog. Bitte geben Sie uns das gesuchte Werk an und wir teilen Ihnen mit, ob Material verf\u00FCgbar ist. Die Bereitstellung von Filmausz\u00FCgen erfolgt auf Anfrage. Weitere Informationen dazu finden Sie in unseren <a href=\"".concat(getUrl(urls.docs.d03, DE), "\" target=\"_blank\">\uD83D\uDDCEBedingungen f\u00FCr die Bereitstellung von Ausz\u00FCgen</a>."),
            text4: '<b>Bitte beachten Sie, dass bei urheberrechtlich geschützten Werken vor der Bereitstellung von Auszügen die schriftliche Genehmigung des Rechteinhabers eingeholt werden muss. Die Verantwortung dafür liegt bei der antragstellenden Person.</b>',
            button1: 'Bestellung von Filmauszügen',
        },
        menu4: {
            title: 'Lizenz und Videomaterial der Schweizer Filmwochenschau',
            text1: 'Zwischen 1940 und 1975 wurde die Schweizer Filmwochenschau als Vorprogramm in allen Schweizer Kinos ausgestrahlt. Die mehr als 6000 Filmreportagen in den drei Landessprachen (Deutsch, Französisch und Italienisch) halten dabei wichtige Momente des politischen, sozialen und kulturellen Lebens in der Schweiz fest. Als öffentliches Informationsmittel im Dienste der geistigen Landesverteidigung hat die Schweizer Filmwochenschau das kollektive audiovisuelle Gedächtnis der Schweiz geprägt.',
            text2: 'Die Elemente auf Film werden in der Cinémathèque suisse aufbewahrt und wurden komplett digitalisiert. Auf memobase.ch können Sie sich alle Ausgaben ansehen:',
            text3: 'Bitte nutzen Sie folgendes Formular, wenn Sie Filmauszüge oder Betriebsmaterial bestellen möchten:',
            link1: '<a href="https://memobase.ch/de/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
            link2: "<a href=\"".concat(getUrl(urls.docs.d03, DE), "\" target=\"_blank\">\uD83D\uDDCEBedingungen f\u00FCr die Bereitstellung von Ausz\u00FCgen sowie Ausgaben der SFW</a>"),
            button1: 'Anfrage für eine Einsichtnahme vor Ort, einen Termin oder eine Auskunft',
        },
    },
    requestsAccessCollection2: {
        text1: "Die Forschungs- und Archivierungszentren in Penthaz und Zürich beherbergen auch Bibliotheksbestände. Der Katalog mit Monographien, Drehbüchern und DVDs kann auf Renouvaud – Sciences et Patrimoine durchsucht werden.",
        text2: 'Die Bestellung von Bibliotheksdokumenten ist nur über <b>ein Renouvaud- oder Bibliopass-Leserkonto</b> möglich. Falls Sie noch kein Konto haben: Füllen Sie dieses <a href="https://db-prod-bcul.unil.ch/pre-inscription/sp/post.php" target="_blank">Formular</a> aus, um sich kostenlos zu registrieren. Die Anmeldung wird durch die CS bestätigt.',
        text3: "Für die Abholung der Dokumente - sei es für die Konsultation vor Ort oder für die Ausleihe zu Hause - ist ein Termin erforderlich. Die Bibliothek nimmt nach Erhalt der Bestellung per E-Mail Kontakt mit der Leserin oder dem Leser auf.",
        link1: '<b>Renouvaud Katalog</b><br><a href="https://cinematheque.renouvaud.ch" target="_blank">https://cinematheque.renouvaud.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, DE), "\" target=\"_blank\">\uD83D\uDDCEDepartement Non-Film: Nutzungsreglement</a>"),
        link3: '<a href="https://www.cinematheque.ch/de/praktische-informationen/anfahrt-und-oeffnungszeiten" target="_blank">🗎Öffnungszeiten</a>',
    },
    requestsAccessCollection3: {
        text1: 'Die Onlinedatenbank Caspar zeigt Ihnen, welche Archivsammlungen und Dokumentationsdossiers (Papierbestände) des Departements Non-Film vorhanden sind.',
        text2: '<b>Caspar bietet jedoch keinen Zugang zu digitalisierten Archivbeständen.</b> Die physischen Archive können nur vor Ort konsultiert werden, je nachdem, wo sie aufbewahrt werden:',
        text3: 'Im <b> Forschungs- und Archivierungszentrum in Penthaz</b>',
        text4: 'Im <b> Forschungs- und Archivierungszentrum in Zürich</b>',
        text5: 'Die <b>Digitalarchive</b> können ebenfalls vor Ort konsultiert werden – wahlweise in Penthaz oder Zürich. Bitte stellen Sie unten Ihre Anfrage für eine Einsichtnahme und geben Sie wenn möglich die Signatur des Bestands, der Dossiers oder der Dokumente an.',
        link1: '<b>Caspar</b><br><a href="https://caspar.cinematheque.ch" target="_blank">caspar.cinematheque.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, DE), "\" target=\"_blank\">\uD83D\uDDCEDepartement Non-Film: Nutzungsreglement</a>"),
        link3: '<a href="https://www.cinematheque.ch/de/praktische-informationen/anfahrt-und-oeffnungszeiten" target="_blank">🗎Öffnungszeiten</a>',
        button1: 'Anfrage zur Einsichtnahme vor Ort',
    },
    requestsAccessCollection4: {
        text1: 'Das Bildarchiv und die musealen Bestände der Cinémathèque suisse umfassen Fotografien, Plakate, Dias, kinematografische Apparate und protokinematografische Objekte.',
        text2: "<b>Die Institution arbeitet daran, den gesamten Sammlungskatalog online zu stellen und den Zugang zu digitalisierten sowie urspr\u00FCnglich digitalen (born-digital) Dokumenten zu erm\u00F6glichen.</b> Sie k\u00F6nnen aber in jedem Fall eine Recherche in den Sammlungen beantragen. Bitte beachten Sie vorab unsere <a href=\"".concat(getUrl(urls.docs.d05, DE), "\" target=\"_blank\">\uD83D\uDDCETarife</a> und lesen Sie unsere <a href=\"").concat(getUrl(urls.docs.d06, DE), "\" target=\"_blank\">\uD83D\uDDCENutzungsbedingungen f\u00FCr zur Verf\u00FCgung gestellte Bilder</a>."),
        text3: 'Bei bestimmten Anfragen (im Rahmen von Forschungsprojekten, Ausstellungen, Publikationen etc.) können Sie sich vor Ort oder aus der Ferne beraten lassen und sich mit einem:einer Dokumentalist:in austauschen, um Ihre Bedürfnisse zu spezifizieren.',
        text4: '<b>Bitte beachten Sie, dass die antragstellende Person selbst dafür verantwortlich ist, allfällige Rechteinhaber von Standbildern ausfindig zu machen und die Nutzungsrechte zu erwerben.</b>',
        button1: 'Bestellung von Standbildern',
        button2: 'Anfrage zur Einsichtnahme vor Ort',
    },
    requestsAccessCollection5: {
        text1: "Um auf die \u00F6ffentlichen Datenbanken (gem\u00E4ss der <a href=\"".concat(getUrl(urls.docs.d09, DE), "\" target=\"_blank\">\uD83D\uDDCESammlungspolitik</a> der Cin\u00E9math\u00E8que suisse) zuzugreifen, nutzen Sie bitte die Suchwerkzeuge auf den entsprechenden Seiten:"),
        text2: 'Im Rahmen von Forschungsarbeiten, Ausstellungsprojekten oder bei anderen <b>spezifischen Anfragen</b> nach Informationen über die Sammlungen der Cinémathèque suisse (dokumentarische Recherchen, die nicht mit einer Vermittlungstätigkeit zusammenhängen) können Sie Auskunft über die nachfolgenden Sammlungen beantragen. Je nach Art der Anfrage ist es möglich, nach Vereinbarung vor Ort Einsicht in die Filmdatenbank zu nehmen. Bitte geben Sie nach Möglichkeit die entsprechenden Referenzen (Bestandsname, Signatur) oder eine detaillierte Filmliste an.',
        text3: '<b>Die Cinémathèque suisse behält sich das Recht vor, die Bearbeitung von Anfragen nach Auskunft über Sammlungen abzulehnen.</b>',
        link1: 'Filmsammlungen',
        link2: 'Bibliothek der Cinémathèque suisse',
        link3: 'Archivbestände und Dokumentationsdossiers',
        link4: 'Bildarchiv und museale Sammlungen',
        button1: 'Anfrage nach Auskunft zu den Sammlungen',
    },
    requestsRequestMaterial1: {
        text1: '<b>Filmmaterial</b>',
        text2: 'Je nach Bedingungen der Hinterlegung kann der:die Hinterlegende die <b>vorübergehende Freigabe von Vorführexemplaren</b> oder den <b>Zugang zum hinterlegten Material</b> beantragen. Bitte nutzen Sie dazu eine der nachstehende Formulare und senden Sie es an die Cinémathèque suisse.',
        text3: "Schweizer Hinterlegenden und Verleihern werden Vorf\u00FChrexemplare innerhalb von mindestens zwei Wochen freigegeben (Versand innerhalb der Schweiz). Die Fristen f\u00FCr die Ausgabe von anderen Arten von Filmmaterial variieren je nach Art der Anfrage. Weitere Informationen finden Sie im Dokument <a href=\"".concat(getUrl(urls.docs.d07, DE), "\" target=\"_blank\">\uD83D\uDDCETarife und Nutzungsbedingungen</a>."),
        text4: '<b>Non-Film-Material</b>',
        text5: 'Hinterlegende können über das Formular zur Einsichtnahme vor Ort Zugang zum hinterlegten Non-Film-Material erhalten oder die vorübergehende Freigabe beantragen. Bitten geben Sie an, was Sie benötigen, und erwähnen Sie in der Beschreibung der Anfrage Ihren Status als Hinterlegende:r.',
        button1: 'Freigabeauftrag für eine Filmvorführung',
        button2: 'Zugang zu hinterlegtem Filmmaterial',
        button3: 'Anfrage zur Einsichtnahme vor Ort',
    },
    requestsOrganizeProjection1: {
        text1: '<b>Vertriebskatalog</b>',
        text2: 'Die Cinémathèque suisse besitzt die Vertriebsrechte von fast 200 Filmen, darunter Werke aus dem Filmerbe (die meisten davon restauriert) und zeitgenössische Autorenfilme, für die Schweiz und teilweise auch für das Ausland. Dieser öffentlich zugängliche Vertriebskatalog ist Ihre erste Anlaufstelle für Werke aus den Filmsammlungen.',
        text3: '<b>Filmsammlungen</b>',
        text4: 'Wie bei allen Kinematheken der Welt ist auch unser Katalog der Filmsammlungen nicht öffentlich zugänglich. Sie können jedoch die Einsichtnahme in oder die Bereitstellung von konkreten Filmkopien bei der Cinémathèque suisse anfragen. Diese Praxis, die von allen Mitgliedern der internationalen Vereinigung der Filmarchive (FIAF) vertreten wird, beruht auf Vertraulichkeitsvereinbarungen mit den Hinterlegenden sowie gesetzlichen Bestimmungen.',
        text5: "<b>Bitte reichen Sie ihre Anfrage \u00FCber das untenstehende Formular ein.</b> Falls der gew\u00FCnschte Titel Teil unseres Vertriebskatalogs ist, werden Sie dar\u00FCber informiert und Sie k\u00F6nnen die Rechte direkt von der Cin\u00E9math\u00E8que suisse erwerben. Anderenfalls werden Sie gebeten, die Zustimmung des Rechteinhabers vorzulegen, damit die Cin\u00E9math\u00E8que suisse das Material freigeben kann. Weitere Informationen finden Sie in den <a href=\"".concat(getUrl(urls.docs.d01, DE), "\" target=\"_blank\">\uD83D\uDDCEBestimmungen und Tarifen f\u00FCr die Nutzung von Filmkopien</a> oder <a href=\"").concat(getUrl(urls.docs.d08, DE), "\" target=\"_blank\">\uD83D\uDDCETarifen f\u00FCr Filme im Vertriebskatalog</a>."),
        text6: 'Die Cinémathèque suisse <b>digitalisiert und transkodiert keine Filme auf Anfrage</b>.',
        link1: '<b>Vertriebskatalog</b><br><a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">cinematheque.ch/filmvertrieb</a>',
        button1: 'Bestellung von Vorführkopien',
    },
    requestsOrganizeProjection2: {
        text1: '<b>Vertriebskatalog</b>',
        text2: 'Digitales Material',
        text3: 'Für Filme, an denen die Cinémathèque suisse die Rechte besitzt, stehen die verfügbaren digitalen Werbeelemente (Plakate, Bilder, Pressedossiers, DCP- oder Videotrailer) im Onlinekatalog frei zum Download zur Verfügung:',
        text4: 'Drucksachen',
        text5: 'Schweizer Kinobetreibende können B1-Plakate und A5-Flyer von Filmen im Vertriebskatalog (nach Verfügbarkeit) zusammen mit den Vorführkopien oder direkt über das untenstehende Formular bestellen.',
        text6: '<b>Bildarchiv</b>',
        text7: 'Um Promotionsmaterial zu finden, das nicht im Online-Vertriebskatalog verfügbar ist, stellen Sie bitte eine Anfrage über das untenstehende Formular für die Bestellung von Standbildern.',
        link1: '<b>Vertriebskatalog</b><br><a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">cinematheque.ch/filmvertrieb</a>',
        button1: 'Vertrieb – Bestellung von Plakaten und Flyern',
        button2: 'Bestellung von Standbildern',
    },
    requestsOrganizeProjection3: {
        text1: '<b>Saalmiete</b>',
        text2: 'Die Cinémathèque suisse verfügt im Kino Capitole über zwei Vorführsäle: den grossen historischen Saal mit 736 Plätzen (Salle Freddy Buache) und einen kleineren Saal mit 140 Plätzen (Salle Lucienne Schnegg).',
        text3: '<b>Saalmiete für Privat- oder Schulvorführungen</b>',
        text4: 'Ab September 2024 werden Sie Ihre Mietanfrage über unsere Online-Plattform einreichen können. Die Cinémathèque suisse nimmt dann Anfragen für Nutzungen ab Januar 2025 entgegen.',
        text5: '<b>Saalmiete für öffentliche Veranstaltungen</b>',
        text6: 'Wenn Sie einen Saal für eine öffentliche Veranstaltung mieten wollen, müssen Sie der Cinémathèque suisse ein Gesuchsdossier einreichen, das die Vorführung eines Films beinhaltet. Die Cinémathèque suisse behält sich das Recht vor, Anfragen abzulehnen.',
        button3: 'Partnerschaftsantrag',
    },
    requestsDiscoverCS1: {
        menuTitle: 'Virtuelle Ausstellungen und Timeline',
        text1: '<b>Virtuelle Ausstellungen</b>',
        text2: 'Als Ergänzung zu den physischen Ausstellungen, die in Zusammenarbeit mit Museen, Festivals und anderen Institutionen realisiert werden, bietet die Cinémathèque suisse thematische Online-Ausstellungen an. Darin zeigt sie emblematische und oft unveröffentlichte Dokumente und hebt verschiedene künstlerische Bewegungen, Genres oder Filmemacher:innen aus der Schweiz und dem Ausland hervor.',
        text3: '<b>Programm folgt</b>',
    },
    requestsDiscoverCS2: {
        menuTitle: 'Das Forschungs- und Archivierungszentrum in Penthaz besuchen',
        text1: 'Die Cinémathèque suisse organisiert auf Anmeldung Führungen im Forschungs- und Archivierungszentrum in Penthaz für Gruppen ab 10 Personen. Diese können thematisch an verschiedene Zielgruppen angepasst werden und dauern etwa 2 Stunden. Sie werden allerdings nur auf Französisch angeboten.',
        text2: '<b>Schulgruppen und Kinder</b>',
        text3: 'Im Mittelpunkt der pädagogischen Aktivitäten steht das spielerische Entdecken der Aufgaben und Berufe der Cinémathèque suisse.',
        text4: '<b>Private und institutionelle Gruppen</b>',
        text5: 'Privaten und institutionellen Gruppen bietet die Cinémathèque suisse eine klassische Führung an. Je nach Verfügbarkeit der entsprechenden Mitarbeitenden ist es auch möglich, einen Besuch auf bestimmte Aspekte zu fokussieren.',
        text6: '<b>Aus Planungsgründen und aufgrund von begrenzten Ressourcen muss jede Anfrage für einen Besuch mindestens 3 Monate im Voraus gestellt werden.</b>',
        button1: 'Führung buchen – Penthaz',
    },
    requestsDiscoverCS3: {
        menuTitle: 'Das Forschungs- und Archivierungszentrum in Zürich besuchen',
        text1: 'Die Cinémathèque suisse bietet auf Voranmeldung Führungen im Forschungs- und Archivierungszentrum Zürich an. Diese können an verschiedene Zielgruppen angepasst werden und dauern etwa zwei Stunden.',
        text2: 'Je nach Verfügbarkeit der Mitarbeitenden ist es möglich, die Führung im Forschungs- und Archivierungszentrum Zürich auf bestimmte Aspekte der Sammlungen auszurichten. Ihre Wünsche können Sie uns gerne bei der Terminvereinbarung mitteilen.',
        button1: 'Führung buchen – Zürich',
    },
    requestsDiscoverCS4: {
        menuTitle: 'Als Gruppe eine Programmvorführung besuchen',
        text1: 'Die Cinémathèque suisse zeigt von Dienstag bis Sonntag Vorführungen im Capitole an.',
        text2: '<b>Zugang und Öffnungszeiten Café-Ticketkasse im Capitole</b>',
        text2subtext1: 'Montag: Geschlossen',
        text2subtext2: 'Dienstag - Samstag: 13:30 - 20:30*',
        text2subtext3: 'Sonntag: 14:00 - 20:30*',
        text2subtext4: '*Bei Sonderöffnungszeiten öffnet das Café-Ticketkasse im Capitole 30 Minuten vor Beginn der ersten Vorstellung.',
        text3: 'Das Vorführungsprogramm und der Kartenverkauf sind auch online zugänglich unter:',
        text4: '<b>Reservierungen für private Gruppen oder Schulklassen</b>',
        text5: 'Ab 10 Personen ist es möglich, eine Vorführung zu Vorzugspreisen zu besuchen - ausgenommen Sondervorstellungen und Vorpremieren. Schülergruppen der Primar- und Sekundarstufe II profitieren ebenfalls von einem Spezialtarif von CHF 5 pro Schüler*in und freiem Eintritt für die begleitenden Lehrpersonen. Sie können Ihre Plätze reservieren und einen Gruppentarif erhalten, indem Sie den entsprechenden Reservierungsantrag unten einreichen.',
        link1: '<a href="https://live.cinematheque.ch" target="_blank">live.cinematheque.ch</a>',
        button1: 'Privat: Gruppenreservation',
        button2: 'Schule: Gruppenreservation',
    },
    requestsSubmitMaterial1: {
        text1: 'Ablieferungen auf Eigeninitiative bereichern kontinuierlich die Bestände der Cinémathèque suisse.',
        text2: '<b>Neue Ablieferungen für die Sammlung</b>',
        text3: 'Jedes Angebot für eine Ablieferung wird vorgängig geprüft – mit Ausnahme von Hinterlegungen, die bereits Gegenstand von Vereinbarungen mit der Cinémathèque suisse sind.',
        text4: "Damit Ablieferungen akzeptiert werden k\u00F6nnen, m\u00FCssen sie den Kriterien der <a href=\"".concat(getUrl(urls.docs.d09, DE), "\" target=\"_blank\">\uD83D\uDDCESammlungspolitik</a> der Cin\u00E9math\u00E8que suisse entsprechen. Im Rahmen dieser Sammlungspolitik k\u00F6nnen Schenkungen oder Hinterlegungen ganz oder teilweise abgelehnt werden. Bitte reichen Sie Ihr Schenkungs- oder Hinterlegungsangebot mit dem Formular unten ein und <b>\u00FCbermitteln Sie uns bitte kein Material, bis wir Ihre Angebot akzeptiert haben</b>."),
        text5: 'Die Aufbereitung und Lagerung von grossen Materialchargen kann besonderen Vereinbarungen unterliegen, die Bearbeitungs- und Lagerungsgebühren nach Kostenvoranschlag beinhalten.',
        text6: 'Die Cinémathèque suisse behält sich das Recht vor, eine erste Auswahl zu treffen, indem sie Elemente, die unbrauchbar, zu schlecht erhalten sind und/oder eine Gefahr für die Sammlung darstellen, aussortiert.',
        text7: "Weitere Informationen zu digitalen Hinterlegungen finden sie in den <a href=\"".concat(getUrl(urls.docs.d10, DE), "\" target=\"_blank\">\uD83D\uDDCEBedingungen f\u00FCr die Hinterlegung digitaler Best\u00E4nde</a>."),
        text8: '<b>Obligatorische Hinterlegungen (Hinterlegungen des BAK oder von Filmen, die von regionalen Fonds unterstützt wurden)</b>',
        text9: 'Informationen zu obligatorischen Hinterlegungen finden Sie auf folgender Seite:',
        link1: 'Hinterlegung von Filmen mit Förderung des BAK oder von anderen regionalen Fonds',
        button1: 'Material hinterlegen oder abliefern',
    },
    requestsSubmitMaterial2: {
        text1: 'In Übereinstimmung mit <a href="https://www.fedlex.admin.ch/eli/cc/2016/291/de" target="_blank">Art. 63 der Verordnung des EDI über die Filmförderung (FiFV)</a> vom 21. April 2016 sind alle, die eine Finanzhilfe des Bundes an die Herstellung eines Films erhalten haben, verpflichtet, der Stiftung Cinémathèque Suisse die vorhandenen Ausgangsdateien der Endfassung (Masterfile) des Films zu überlassen. Werke, die von anderen regionalen Fonds unterstützt werden (cinéforom, Berner Filmförderung, Zürcher Filmstiftung etc.), unterliegen gemäss den geltenden Statuten und Vereinbarungen ebenfalls dieser Auflage.',
        text2: 'Die Aufgabe der Cinémathèque suisse ist es, Ihre Produktion in ihrer ursprünglichen Maximalqualität langfristig zu erhalten. Indem Sie Ihr Material hinterlegen, sorgen Sie dafür, dass es auch in Zukunft bestehen bleibt. Die Cinémathèque suisse sammelt auch das Betriebsmaterial der von ihr aufbewahrten Filme. Diese Objekte werden vom Departement Non-Film übernommen.',
        text3: '<b>So gehen Sie vor, um Filme zu hinterlegen, die eine Förderung des BAK oder von einem anderen regionalen Fonds erhalten haben:</b>',
        text4: "F\u00FCllen Sie die <a href=\"".concat(getUrl(urls.docs.d11, DE), "\" target=\"_blank\">\uD83D\uDDCEHinterlegungsbest\u00E4tigung zur Archivierung</a> aus (italienische Fassung <a href=\"").concat(getUrl(urls.docs.d11, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhier</a> verf\u00FCgbar)."),
        text5: "Stellen Sie sicher, dass das Material die <a href=\"".concat(getUrl(urls.docs.d12, DE), "\" target=\"_blank\">\uD83D\uDDCEtechnischen Vorgaben f\u00FCr die obligatorische Hinterlegung digitaler Filmelemente</a> erf\u00FCllt (italienische Fassung  <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhier</a> verf\u00FCgbar)."),
        text6: 'Senden Sie das Material mit der Absenderadresse an:<br><br><b>Cinémathèque suisse<br>Centre de recherche et d’archivage<br>Département Film / Dépôt obligatoire<br>Chemin de La Vaux 1<br>1303 Penthaz</b><br><br><b>Wenn möglich, legen Sie der Sendung bitte 6 Exemplare von allen verfügbaren gedruckten Promotionsmaterialien bei (Plakate, Flyer, Betriebsfotos, Postkarten).</b>',
        text7: 'Die Cinémathèque suisse informiert Sie anschliessend darüber, ob Ihre Hinterlegung den Anforderungen entspricht und lässt sie beim BAK und/oder den anderen involvierten Stellen bestätigen.',
        text8: 'Wenn Sie auch das digitale Promotionsmaterial bei uns hinterlegen, wird sich ein:e Mitarbeiter:in für die Akquisition mit Ihnen in Verbindung setzen.',
    },
    formViewingRequest: {
        text1: 'Visionierungsanfrage',
    },
    formViewingRequest1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Grund für die Anfrage',
        text4: 'Beschreibung Ihrer Anfrage sowie des gesuchten Werks, falls Ihnen der Titel nicht bekannt ist.',
        text5: 'Grund für die Anfrage / Beschreibung der Forschungsarbeit:<br><ul><li>Thema</li><li>Institution</li><li>Geplante Publikation</li><li>... </li></ul>',
    },
    formViewingRequest2: {
        text1: 'Gewünschter Film',
        text2: 'Vorname Regisseur:in',
        text3: 'Name Regisseur:in',
        text4: 'Originaltitel / deutscher Titel *',
        text5: 'Nachdem wir Ihre Anfrage bearbeitet haben, informieren wir Sie darüber, ob Material zur Verfügung steht und welche Möglichkeiten zur Visionierung Sie haben. Sie können dann gegebenenfalls eine Visionierung mit uns vereinbaren.',
        text6: 'Produktionsjahr',
        text7: 'Anzahl gesuchter Filme',
    },
    formViewingRequest3: {
        text1: 'Gewünschte Version',
        text2: 'Je nach Verfügbarkeit:<br><ul><li>OF Französische UT</li><li>OF Deutsche UT</li><li>OF Italienische UT</li><li>Andere</li></ul>Falls Sie «Andere» gewählt haben, geben Sie bitten die gewünschte Version an.<br><br>Wir bemühen uns darum, Ihnen wenn möglich die gewünschte Version zur Verfügung zu stellen. Falls diese nicht verfügbar ist, informieren wir Sie über die Alternativen.',
    },
    formViewingRequest4: {
        text1: 'Bemerkungen',
        text2: 'Bitte geben Sie hier Bemerkungen oder weitere Details an, die im Formular nicht erfasst wurden.',
    },
    formViewingRequest5: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d02, DE), "\" target=\"_blank\">\uD83D\uDDCETarife f\u00FCr die Einsichtnahme vor Ort</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formViewingRequest6: {
        text1: 'Ohne vorherige Bestätigung Ihrerseits werden keine kostenpflichtigen Leistungen erbracht.<br><br>' +
            "Für Kunden ausserhalb der Schweiz: Vorauszahlungen auf Rechnung.",
    },
    formClipRequest: {
        text1: 'Bestellung von Filmauszügen',
    },
    formClipRequest1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Beschreibung Ihrer Anfrage',
        text5: 'Für die Bestellung von Ausgaben der Schweizer Filmwochenschau, nutzen Sie bitte das <a href="/forms/cine-journal">entsprechende Formular</a>.<br><br>Die Antwortzeit beträgt 10 Werktage.<br><br>Wir senden Ihnen dann eine Offerte für die angefragten Ausgaben.<br><br>Falls sie diese akzeptieren, benötigen wir für die Erstellung und Lieferung der Dateien <b>zusätzlich 4 bis 6 Wochen</b>.',
    },
    formClipRequest2: {
        text1: 'Betreffendes Werk',
        text2: 'Vorname Regisseur:in',
        text3: 'Name Regisseur:in',
        text4: 'Originaltitel / deutscher Titel',
        text5: 'Bitte beachten Sie, dass Sie die Genehmigung des Rechteinhabers einholen müssen, bevor ein Filmauszug ausgeliefert werden kann. Einige restaurierte bzw. digitalisierte Filmelemente können auf <a href="https://memobase.ch/de/search?filter[institution][0]=Cin%C3%A9math%C3%A8que%20suisse" target="_blank">Memobase</a> und <a href="http://www.archimob.ch/" target="_blank">Archimob</a> eingesehen werden.',
    },
    formClipRequest3: {
        text1: 'Nutzungsgebiet',
        text2: {
            option1: 'Schweiz',
            option2: 'Europa',
            option3: 'Weltweit',
        },
        text3: 'Nutzungsart',
        text4: {
            option1: 'Private Nutzung',
            option2: 'Forschungsarbeit',
            option3: 'Öffentliche Vorführung',
            option4: 'Audiovisuelle Produktion',
            option5: 'Ausstellung',
            option6: 'Andere',
        },
        text5: 'Vertriebskanal',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'VOD',
            option4: 'Kino',
            option5: 'Installation',
            option6: 'Anderer',
        },
    },
    formClipRequest4: {
        text1: 'Bemerkungen',
    },
    formClipRequest5: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d03, DE), "\" target=\"_blank\">\uD83D\uDDCEBedingungen f\u00FCr die Bestellung von Ausz\u00FCgen</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formCineJournal: {
        text1: 'Lizenz und Videomaterial der Schweizer Filmwochenschau',
    },
    formCineJournal1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Grund für die Anfrage oder Beschreibung des Projekts, bei dem die Filmelemente verwendet werden sollen',
        text5: 'Nachdem Sie Ihre Anfrage eingereicht haben, melden wir uns bei Ihnen mit einem Kostenvoranschlag für die angefragten Leistungen.<br><br>Die Bearbeitungszeit beträgt mindestens 4 bis 6 Wochen.',
    },
    formCineJournal2: {
        text1: 'Betreffende Filmwochenschau',
        text2: 'Haupttitel / Memobase ID',
        text3: 'Titel der Sendung',
        text4: 'Ich möchte gerne zusätzliches Material für diese Schweizer Filmwochenschau bestellen.',
        text5: 'Nutzungsdatum',
        text6: 'Bitte geben Sie die Referenz (Memobase ID, Nummer oder Datum der Ausgabe) der gewünschten Schweizer Filmwochenschau an, wenn Sie sie kennen.',
    },
    formCineJournal3: {
        text1: 'Nutzungsgebiet',
        text2: {
            option1: 'Schweiz',
            option2: 'Europa',
            option3: 'Weltweit',
        },
        text3: 'Nutzungsart',
        text4: {
            option1: 'Private Nutzung',
            option2: 'Forschungsarbeit',
            option3: 'Öffentliche Vorführung',
            option4: 'Audiovisuelle Produktion',
            option5: 'Ausstellung',
            option6: 'Andere',
        },
        text5: 'Vertriebskanal',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'VOD',
            option4: 'Kino',
            option5: 'Installation',
            option6: 'Computer',
        },
    },
    formCineJournal4: {
        text1: 'Bemerkungen',
    },
    formCineJournal5: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d13, DE), "\" target=\"_blank\">\uD83D\uDDCETarife f\u00FCr Lizenzen und Material zur Schweizer Filmwochenschau</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formOnSiteConsultation: {
        text1: 'Anfrage zur Einsichtnahme vor Ort',
    },
    formOnSiteConsultation1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Beschreibung Ihrer Anfrage',
        text5: 'In Penthaz stehen den Nutzer:innen zwei Lesesäle zur Verfügung. Die Räumlichkeiten sind mit einem Kopierer und WLAN ausgestattet.<br><br>Einer der Lesesäle kann für Gruppenarbeiten zur Verfügung gestellt werden. Bitte erkundigen Sie sich bei der Terminvereinbarung über die Verfügbarkeit.<br><br>Das Forschungs- und Archivierungszentrum in Penthaz verfügt über eine Cafeteria mit Getränke- und Snackautomat sowie Mikrowelle.',
    },
    formOnSiteConsultation2: {
        text1: 'Kategorie und Beschreibung der Dokumente, die sie einsehen wollen',
        text2: {
            option1: 'Archivbestände',
            placeholder1: 'Titel, Thema oder Signatur',
            option2: 'Dokumentationsdossiers',
            placeholder2: 'Titel, Thema oder Signatur',
            option3: 'Monographien, Zeitschriften, Drehbücher, Blu-rays, DVDs',
            placeholder3: 'Titel, Thema oder Signatur',
            option4: 'Standbilder',
            placeholder4: 'Titel, Thema oder Signatur',
            option5: 'Andere',
            placeholder5: 'Spezifizieren',
        },
        text3: 'Titel, Thema oder Signatur',
        text4: 'Spezifizieren',
        text5: 'Mindestens eine Kategorie',
    },
    formOnSiteConsultation3: {
        text1: 'Digitale Dokumente vor Ort einsehen',
        text2: {
            option1: 'Forschungs- und Archivierungszentrum in Penthaz',
            option2: 'Forschungs- und Archivierungszentrum in Zürich',
        },
        text3: 'Digitalisate können in Penthaz oder Zürich eingesehen werden. Bitte geben Sie Ihre Präferenz an.<br><br>Physische Dokumente können nur am Ort ihrer Aufbewahrung eingesehen werden.<br><br><b><a href="https://www.cinematheque.ch/de/praktische-informationen/anfahrt-und-oeffnungszeiten" target="_blank"> Lesesäle und Öffnungszeiten</a>',
        text4: 'Gewünschtes Datum',
        text5: 'Bitte beachten Sie, dass Sie Ihren Besuch mindestens 10 bis 15 Tage im Voraus anmelden müssen.',
    },
    formOnSiteConsultation4: {
        text1: 'Bemerkungen',
    },
    formOnSiteConsultation5: {
        text1: "Ich habe das <a href=\"".concat(getUrl(urls.docs.d04, DE), "\" target=\"_blank\">\uD83D\uDDCENutzungsreglement des Departements Non-Film</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formStillImages: {
        text1: 'Bestellung von Standbildern',
    },
    formStillImages1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Film, Person, Werk, Thema, Art der gewünschten Dokumente',
        text5: 'Bitte beschreiben Sie das gewünschte Standbild so genau wie möglich. Geben Sie wenn möglich auch eine Filmografie oder die Referenz des Archivfonds an.',
    },
    formStillImages2: {
        text1: 'Nutzungsrahmen',
        text2: {
            option1: 'Private Nutzung',
            option2: 'Forschungsarbeit',
            option3: 'Promotion – Öffentliche Vorführung',
            option4: 'Gedruckte oder digitale Publikation',
            option5: 'Ausstellung',
            option6: 'Ausstellungskatalog',
            option7: 'Videoproduktion',
            option8: 'Buch',
            option9: 'Ausleihe',
            option10: 'Andere',
        },
        text3: 'Die Auflösung der digitalen Bilder kann abhängig von den verfügbaren Elementen später festgelegt werden.<br><br> Option «Andere»: Die Möglichkeit der Nutzung ist abhängig vom Format, der Verfügbarkeit des Dokuments und der Anzahl der zu verarbeitenden Dokumente.',
    },
    formStillImages3: {
        text1: 'Gewünschter Liefertermin',
        text2: 'Die Mindestlieferfrist beträgt 10 bis 15 Werktage, ohne Garantie und abhängig vom Format, der Verfügbarkeit des Dokuments und der Anzahl der zu bearbeitenden Dokumente.',
    },
    formStillImages4: {
        text1: 'Bemerkungen',
    },
    formStillImages5: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d06, DE), "\" target=\"_blank\">\uD83D\uDDCENutzungsbedingungen f\u00FCr zur Verf\u00FCgung gestellte Bilder</a> zur Kenntnis genommen."),
        text2: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d05, DE), "\" target=\"_blank\">\uD83D\uDDCETarife</a> zur Kenntnis genommen."),
        text3: 'Anfrage senden',
    },
    formInformationRequest: {
        text1: 'Anfrage nach Informationen zu den Sammlungen',
    },
    formInformationRequest1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Bitte beschreiben Sie Ihre Anfrage und geben Sie nach Möglichkeit folgende Informationen an: Titel, Person(en), Werk(e), Thema/Themen, Art(en) der gesuchten Dokumente etc.',
        text5: 'Bitte geben Sie möglichst viele Details an und nennen Sie alle verfügbaren Referenzen (Fonds, Signaturen) oder eine umfassende Filmografie.<br><br>Ihre Anfrage wird so schnell wie möglich bearbeitet.',
    },
    formInformationRequest2: {
        text1: 'Sammlung',
        text2: {
            option1: 'Film',
            option2: 'Non-Film',
            option3: 'Alle Sammlungen',
        },
        text3: 'Auf welche Sammlung bezieht sich Ihre Anfrage?',
    },
    formInformationRequest3: {
        text1: 'Verwendung der Informationen',
        text2: {
            option1: 'Forschungsarbeit',
            option2: 'Ausstellungsprojekt',
            option3: 'Anderes',
        },
        text3: 'Für welchen Zweck brauchen Sie die Informationen?',
    },
    formInformationRequest4: {
        text1: 'Bemerkungen',
    },
    formInformationRequest5: {
        text1: 'Anfrage senden',
    },
    formReleaseOrder: {
        text1: 'Freigabeauftrag',
    },
    formReleaseOrder1: {
        text1: 'Grund für die Anfrage',
        text2: 'Beschreibung der Anfrage',
        text3: 'Falls nötig, beschreiben Sie bitte kurz Ihr Anliegen.<br><br>Die Mindestbearbeitungszeit beträgt 10 Werktage.',
    },
    formReleaseOrder2: {
        text1: 'Betreffende(r) Fonds oder Ablieferung',
        text2: 'Referenz(en) (z. B. Meier Hans 2020)',
        text3: 'Betreffender Film',
        text4: 'Vorname Regisseur:in',
        text5: 'Name Regisseur:in',
        text6: 'Originaltitel / deutscher Titel *',
        text7: 'Sprachversion (z. B. E/df)',
        text8: 'CS-Signatur, falls bekannt (z. B. 1999-0123-0101)',
        text9: 'Vorführkopie',
        text10: {
            placeholder: 'Art der Kopie wählen',
            option1: '35 mm',
            option2: '16 mm',
            option3: 'DCP',
        },
        text11: 'Daten der Vorführung',
        text12: 'Erste Vorführung',
        text13: 'Letzte Vorführung',
    },
    formReleaseOrder3: {
        text1: "Bitte geben Sie die Zielkoordinaten der Kopien an.<br><br>" +
            "<b>Für die Schweiz:</b><br>" +
            "Die Kopien werden mindestens 10 Tage vor dem ersten Vorführtermin per Postversand gegen Unterschrift geschickt.",
        text2: "Die Rechnungsstellung erfolgt in dem Monat, der auf die letzte Vorführung folgt.<br><br>" +
            "Tarife ohne MwSt.<br>" +
            "· Bewegungsgebühren: CHF 100.- pro Kopie<br><br>" +
            "Versandkosten exkl. MwSt.:<br>" +
            "· CHF 50.- pro Kopie<br>" +
            "· Der Expressversand kostet zusätzlich CHF 20 pro Kopie.",
    },
    formReleaseOrder4: {
        text1: 'Bemerkungen',
    },
    formReleaseOrder5: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d07, DE), "\" target=\"_blank\">\uD83D\uDDCETarife und Nutzungsbedingungen</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formReleaseOrder6: {
        text1: 'Nombre de films pour la sortie',
        text2: 'Un maximum de 10 films peuvent être sélectionnés pour une sortie.',
    },
    formMaterialAccess: {
        text1: 'Zugang zu Material',
    },
    formMaterialAccess1: {
        text1: 'Grund für die Anfrage',
        text2: 'Beschreibung der Anfrage',
        text3: 'Falls nötig, beschreiben Sie bitte kurz Ihr Anliegen.<br><br>Die Mindestbearbeitungszeit beträgt 10 Werktage.',
    },
    formMaterialAccess2: {
        text1: 'Betreffende(r) Fonds oder Ablieferung',
        text2: 'Referenz(en) (z. B. Meier Hans 2020)',
        text3: 'Betreffender Film',
        text4: 'Vorname Regisseur:in',
        text5: 'Name Regisseur:in',
        text6: 'Originaltitel / deutscher Titel *',
        text7: 'Sprachversion (z. B. E/df)',
        text8: 'CS-Signatur, falls bekannt (z. B. 1999-0123-0101)',
        text9: 'Art des Elements/der Elemente',
        text10: {
            option1: 'Vorführkopie',
            option2: 'Abzug',
            option3: 'Archivkopie',
            option4: 'Andere',
        },
        text11: 'Falls «Andere», bitte Art des Elements angeben',
        text12: 'Die Herausgabe von Material kann anschliessend je nach Bedarf organisiert werden.',
    },
    formMaterialAccess3: {
        text1: 'Bemerkungen',
    },
    formMaterialAccess4: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d07, DE), "\" target=\"_blank\">\uD83D\uDDCETarife und Nutzungsbedingungen</a> zur Kenntnis genommen."),
        text2: 'Anfrage senden',
    },
    formMaterialAccess5: {
        text1: "Gegebenenfalls wird Ihnen ein Kostenvoranschlag zugesandt.<br><br>" +
            "Wir werden ohne Ihre vorherige Zustimmung keine kostenpflichtigen Leistungen erbringen.<br><br>" +
            "Für Kunden ausserhalb der Schweiz: Vorauszahlungen auf Rechnung.",
    },
    formProjectionCopy: {
        text1: 'Bestellung einer Vorführkopie',
    },
    formProjectionCopy1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Bestellung der Vorführkopie(n) aus den Filmsammlungen',
        text4: 'Bitte geben Sie für jeden Film folgende Details an:<br>Regisseur:in, Originaltitel oder deutscher Titel, Produktionsjahr',
        text5: 'Falls nötig, beschreiben Sie bitte kurz Ihr Projekt.<br><b>Für die Schweiz:</b><br>Die Mindestbearbeitungszeit beträgt 10 Werktage.<br><br><b>Für das Ausland:</b><br>Die Mindestbearbeitungszeit beträgt 40 Werktage.',
    },
    formProjectionCopy2: {
        text1: 'Gewünschter Film',
        text2: 'Vorname Regisseur:in',
        text3: 'Name Regisseur:in',
        text4: 'Originaltitel / deutscher Titel *',
        text5: 'Daten der Vorführung',
        text6: 'Erste Vorführung (mind. 10 Tage im Voraus bestellen) *',
        text7: 'Letzte Vorführung *',
        text8: 'Anzahl Vorführungen pro Film',
        text9: 'Provisorische Daten',
        text10: '',
        text11: 'Produktionsjahr',
    },
    formProjectionCopy3: {
        text1: 'Gewünschte Sprachversion',
        text2: 'Gewünschter Träger',
        text3: {
            option1: '35-mm-Vorführkopie',
            option2: 'DCP – digitales Kino',
            option3: 'Blu-ray oder digitale Projektionsdatei',
        },
        text4: 'Für Filme, die nicht im Vertriebskatalog sind, kann die Verfügbarkeit eines Projektionsträgers nicht garantiert werden.<br><br>35-mm-Kopien erfüllen bei der Herausgabe lediglich technische Mindestanforderungen, ohne Garantie für die Projektionsqualität.<br><br>Die Cinémathèque suisse digitalisiert und transkodiert keine Filme auf Anfrage.',
        text5: {
            label: 'Sprachversion',
            placeholder: 'Sparchversion auswählen',
            option1: 'OV mit französischen UT',
            option2: 'OV mit deutschen UT',
            option3: 'OV mit italienischen UT',
            option4: {
                label: 'Andere Sprachversion',
                text1: 'Andere Version',
                text2: 'Bitte angeben *',
            }
        }
    },
    formProjectionCopy4: {
        text1: 'Ort der Vorführung',
        text2: 'Name des Kinos/der Einrichtung',
        text3: 'Land der Vorführung',
        text4: 'Art des Eintritts',
        text5: {
            option1: 'Bezahlter Eintritt',
            option2: 'Kostenloser Eintritt',
            option3: 'Festival',
        },
    },
    formProjectionCopy5: {
        text1: 'Gedrucktes Promotionsmaterial',
        text2: {
            option1: 'B1-Plakate',
            option2: 'A5-Flyer',
        },
        text3: 'Menge',
        text4: 'Benötigen Sie für Filme aus dem Vertriebskatalog gedrucktes Promotionsmaterial? (nach Verfügbarkeit)<br><br> Bitte beachten Sie, dass Sie nur Promotionsmaterial für Filme im Vertriebskatalog anfragen können: <a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">www.cinematheque.ch/filmvertrieb</a>.',
    },
    formProjectionCopy6: {
        text1: 'Bemerkungen',
    },
    formProjectionCopy7: {
        text1: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d01, DE), "\" target=\"_blank\">\uD83D\uDDCEBestimmungen und Tarife f\u00FCr die Nutzung von Filmkopien</a> zur Kenntnis genommen."),
        text2: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d08, DE), "\" target=\"_blank\">\uD83D\uDDCETarifs des films au catalogue de diffusion</a> zur Kenntnis genommen."),
        text3: 'Anfrage senden',
    },
    formProjectionCopy8: {
        text1: "<b>Für die Schweiz:</b><br>" +
            "∙ Die Kopien werden mindestens 10 Tage vor dem ersten Vorführtermin per normaler Post mit Unterschrift versandt.<br>" +
            "∙ Für eine Expresssendung wird ein Zuschlag von CHF 20.- zzgl. MwSt. pro Kopie erhoben.<br><br>" +
            "<b>Für Ausland:</b><br>" +
            "∙ Die Organisation von Transport und Zoll sowie die damit verbundenen Kosten sind Sache der anfragenden Person.",
    },
    formProjectionCopy9: {
        text1: "<b>Für die Schweiz:</b><br>" +
            "∙ Die Rechnungsstellung erfolgt in dem Monat, der auf das letzte Vorführungsdatum folgt.<br><br>" +
            "<b>Für Ausland:</b><br>" +
            "∙  Es wird eine Vorauszahlung auf die Rechnung verlangt, bevor die Kopie für den Spediteur freigegeben wird.<br>" + // HELP
            "∙ Zoll- und Transportkosten sind vom Antragsteller zu tragen.<br>",
    },
    formProjectionCopy10: {
        text1: '<b>Für die Schweiz:</b><br>Die Rechte für Filme im Vertriebskatalog können direkt bei der Cinémathèque suisse erworben werden.',
        text2: '<b>Für das Ausland:</b><br>Bitte legen Sie die vorgängige Zustimmung der Rechteinhaber vor, damit die Cinémathèque suisse das Material herausgeben kann.',
    },
    formPromotionalMaterial: {
        text1: 'Vertrieb – Bestellung von Promotionsmaterial',
    },
    formPromotionalMaterial1: {
        text1: 'Gewünschter Film',
        text2: 'Vorname Regisseur:in',
        text3: 'Name Regisseur:in',
        text4: 'Originaltitel / deutscher Titel *',
    },
    formPromotionalMaterial2: {
        text1: 'Gedrucktes Promotionsmaterial',
        text2: {
            option1: 'B1-Plakate',
            option2: 'A5-Flyer',
        },
        text3: 'Menge',
        text4: 'Digitales Promotionsmaterial für Filme aus dem Vertriebskatalog ist frei verfügbar unter: <a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">www.cinematheque.ch/filmvertrieb</a>.',
    },
    formPromotionalMaterial3: {
        text1: 'Gewünschter Liefertermin',
        text2: 'Mindestfrist von 10 Werktagen.',
    },
    formPromotionalMaterial4: {
        text1: 'Bemerkungen',
    },
    formPromotionalMaterial5: {
        text1: 'Anfrage senden',
    },
    formPromotionalMaterial6: {
        text1: "Die Versand- und Materialkosten werden von der Cinémathèque Suisse im Rahmen der von ihr vermittelten Vorführungen in der Schweiz übernommen.<br><br>" +
            "Für jede andere Verwendung wird eine Gebühr von 15.- CHF inkl. MwSt. pro Poster, 0.20 CHF inkl. MwSt. pro Flyer und eine Liefergebühr von 11.- CHF inkl. MwSt. pro Sendung berechnet.<br><br>" +
            "Kostenpflichtige Leistungen werden nur erbracht, wenn Sie diese vorher bestätigt haben.",
    },
    formRoomRental: {
        text1: 'Mietanfrage',
        conditions: {
            general: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d14, DE), "\" target=\"_blank\">\uD83D\uDDCEAllgemeine Bedingungen f\u00FCr die Vermietung von Kinos\u00E4len</a> zur Kenntnis genommen*"),
            cinematographe: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen*',
            capitole: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen*',
        },
        submit: 'Anfrage senden',
    },
    formRoomRental1: {
        text1: 'Titel der Anfrage',
        text2: {
            option1: 'Private Vorführung',
            option2: 'Schulvorführung',
        },
        text3: 'Sie haben angegeben, dass Sie Ihr eigenes Projektionsmaterial mitbringen.<br><br>🠚 Sie verpflichten sich, die Vorführrechte direkt beim Rechteinhaber zu erwerben und uns dessen Genehmigung spätestens 10 Werktage vor der Vorführung zu übermitteln.<br><br>🠚 Sie verpflichten sich, das Vorführmaterial spätestens 10 Tage vor dem Vorführtermin an die Cinémathèque suisse zu senden:<br><br><b>Cinémathèque suisse<br>André Schäublin<br>Chemin de la Vaux 1<br>1303 Penthaz</b><br><b>Wenn die Cinémathèque suisse die Genehmigung oder das Medium nicht innerhalb der gesetzten Frist erhält, behält sie sich das Recht vor, die Saalmiete zu annullieren und eine Annullierungsgebühr zu verlangen.</b><br><br>Bei einer Annullierung durch die mietende Person weniger als 10 Arbeitstage vor dem Nutzungsdatum wird eine Gebühr von mindestens CHF 200 (oder 10 % des Mietpreises) in Rechnung gestellt.',
    },
    formRoomRental2: {
        text1: 'Gewünschter Kinosaal',
        text2: {
            option1: 'Cinématographe',
            option2: 'Capitole',
        },
        text3: 'Das Capitole wird bis Ende 2023 umfassend renoviert und steht in dieser Zeit nicht zur Verfügung.',
    },
    formRoomRental3: {
        text1: 'Gewünschtes Datum',
        text2: 'Gewünschte Zeit',
        text3: 'Mindestfrist von 2 Monaten zwischen der Anfrage und dem 1. Miettermin.<br><br><b>Verfügbarkeit</b><br>Unter Vorbehalt<br><br><b>Cinématographe<br>Casino de Montbenon<br>3 Allée Ernest-Ansermet<br>1003 Lausanne</b><br> Montag bis Samstag<br>9:00–12:00 Uhr<br><br>Dienstag und Mittwoch<br>12:00–20:00 Uhr<br><br>Sonntag und Feiertage<br> Geschlossen<br><b>Capitole</b><br> Nicht verfügbar: Renovierungsarbeiten bis Ende 2023.',
    },
    formRoomRental4: {
        text1: 'Bemerkungen',
    },
    formRoomRental6: {
        text1: 'Erwartete Anzahl Zuschauer:innen *',
    },
    formRoomRental7: {
        text1: 'Ohne vorherige Bestätigung Ihrerseits werden keine kostenpflichtigen Leistungen erbracht.<br><br>' +
            "Für Kunden ausserhalb der Schweiz: Vorauszahlungen auf Rechnung.",
    },
    formRoomRentalFilm: {
        text1: 'Mietanfrage mit Ausleihe einer Filmkopie',
        conditions: {
            general: "Ich habe die <a href=\"".concat(getUrl(urls.docs.d14, DE), "\" target=\"_blank\">\uD83D\uDDCEAllgemeine Bedingungen f\u00FCr die Vermietung von Kinos\u00E4len</a> zur Kenntnis genommen*"),
            cinematographe: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen*',
            capitole: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen*',
        },
        submit: 'Anfrage senden',
    },
    formRoomRentalFilm1: {
        text1: 'Titel der Anfrage',
        text2: 'Vorname Regisseur:in',
        text3: 'Name Regisseur:in',
        text4: 'Originaltitel / deutscher Titel *',
        text5: 'Sie haben angegeben, dass sie mit der Raummiete auch eine Vorführkopie eines Films aus den Sammlungen der Cinémathèque suisse mieten möchten.<br><br>🠚 Sie können einen Film aus dem <a href="https://www.cinematheque.ch/filmvertrieb" target="_blank">Vertriebskatalog</a> wählen. Für diese Filme besitzt die Cinémathèque suisse die Rechte und kann digitale Vorführkopien zur Verfügung stellen.<br><br>🠚 Oder sie geben uns den Titel des Films an, den Sie gerne zeigen möchten, wenn er nicht im Vertriebskatalog ist.<ul><li>Wir suchen dann in unseren Filmsammlungen danach (digitale 35-mm-Kopien).</li><li>Wir informieren Sie über die verfügbaren Vorführkopien.</li><li>Sie verpflichten sich, die Vorführrechte direkt mit dem Rechteinhaber zu regeln.</li><li>Wenn keine Kopie verfügbar ist, geben wir Ihnen Alternativen an, aus denen Sie wählen können.</li></ul>',
    },
    formRoomRentalFilm2: {
        text1: 'Gewünschter Film',
        text2: {
            option1: 'Private Vorführung',
            option2: 'Schulvorführung',
        },
    },
    formRoomRentalFilm3: {
        text1: 'Gewünschter Kinosaal',
        text2: {
            option1: 'Cinématographe',
            option2: 'Capitole',
            option3: 'Capitole, Salle Freddy Buache',
            option4: 'Capitole, Salle Lucienne Schnegg',
        },
        text3: 'Das Capitole wird bis Ende 2023 umfassend renoviert und steht in dieser Zeit nicht zur Verfügung.',
    },
    formRoomRentalFilm4: {
        text1: 'Gewünschtes Datum',
        text2: 'Gewünschte Zeit',
        text3: 'Mindestfrist von 2 Monaten zwischen der Anfrage und dem 1. Miettermin.<br><br><b>Verfügbarkeit</b><br>Unter Vorbehalt<br><br><b>Cinématographe<br>Casino de Montbenon<br>3 Allée Ernest-Ansermet<br>1003 Lausanne</b><br> Montag bis Samstag<br>9:00–12:00 Uhr<br><br>Dienstag und Mittwoch<br>12:00–20:00 Uhr<br><br>Sonntag und Feiertage<br>Geschlossen<br><b>Capitole</b><br>Nicht verfügbar: Renovierungsarbeiten bis Ende 2023.',
        text4: 'Mindestfrist von 2 Monaten zwischen der Anfrage und dem 1. Miettermin.<br><br><b>Verfügbarkeit</b><br>Unter Vorbehalt<br><br><b>Cinéma Capitole<br>Avenue du Théâtre 6<br>1005 Lausanne</b><br> Montag bis Samstag<br>9:00–12:00 Uhr<br><br>Dienstag und Mittwoch<br>12:00–20:00 Uhr<br><br>Sonntag und Feiertage<br>Geschlossen',
    },
    formRoomRentalFilm5: {
        text1: 'Bemerkungen',
    },
    formRoomRentalFilm6: {
        text1: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen.',
        text2: 'Ich habe die <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Allgemeinen Nutzungsbedingungen</a> zur Kenntnis genommen.',
        text3: 'Anfrage senden',
    },
    formRoomRentalFilm7: {
        text1: 'Ohne vorherige Bestätigung Ihrerseits werden keine kostenpflichtigen Leistungen erbracht.<br><br>' +
            "Für Kunden ausserhalb der Schweiz: Vorauszahlungen auf Rechnung.",
    },
    formPartnershipRequest: {
        text1: 'Partnerschaftsantrag',
    },
    formPartnershipRequest1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Allgemeine Beschreibung Ihrer Anfrage, Wunschtermin(e), Thema/Themen und/oder Film(e)',
        text5: 'Die Cinémathèque suisse stellt ihre Räume das ganze Jahr hinüber zahlreichen Institutionen und Festivals zur Verfügung.<br><br>Ihre Anfrage wird insbesondere im Hinblick auf die Art der geplanten Veranstaltung und die Verfügbarkeit der Kinosäle geprüft.',
    },
    formPartnershipRequest2: {
        text1: 'Zielpublikum',
        text2: {
            option1: 'Alle',
            option2: 'Junges Publikum',
        },
        text3: 'An welches Publikum richtet sich Ihre Veranstaltung?',
        text4: 'Kulturvermittlung',
        text5: {
            option1: 'Ja',
            option2: 'Nein',
        },
        text6: 'Planen Sie Kulturvermittlungsaktivitäten im Rahmen der Veranstaltung? (Aktivitäten für Kinder, Schulgruppen etc.)',
        text7: 'Beschreibung der Aktivitäten',
        text8: 'Wenn «Ja», beschreiben Sie bitte kurz die geplanten Aktivitäten.',
    },
    formPartnershipRequest3: {
        text1: 'Bemerkungen',
    },
    formPartnershipRequest4: {
        text1: 'Anfrage senden',
    },
    formVisitBooking: {
        text1: 'Besuch des Archivierungszentrums in Penthaz',
    },
    formVisitBooking1: {
        text1: 'Art des Besuchs',
        text2: {
            option1: 'Klassische Führung',
            option2: 'Magische Tour (für 7- bis 11-Jährige)',
        },
        text3: 'Wählen Sie eine Führung aus, um eine Beschreibung davon zu sehen.<br><br>Die Führungen werden auf Französisch von einem Team von Mitarbeitenden der Cinémathèque suisse geleitet, die – parallel zu ihrer Arbeit – abwechselnd ihre verschiedenen Abteilungen vorstellen. Aus diesem Grund organisieren wir maximal eine Führung pro Woche und bitten Sie, uns Ihre Anfrage möglichst früh zukommen zu lassen.<br><br>Die Führungen sind Teil des von der Cinémathèque suisse angebotenen Kulturvermittlungsprogramms und sind kostenlos.',
    },
    formVisitBooking2: {
        text1: 'Gewünschtes Datum des Besuchs',
        text2: 'Gewünschte Zeit',
        text3: 'Bitte reichen Sie Ihre Anfrage mindestens 3 Monate vor dem gewünschten Besuchstermin ein.<br><br><b>Centre de recherche et d’archivage<br>Chemin de la Vaux 1<br>1303 Penthaz</b><br><br><b>Besuchszeiten</b><br><br><b>Klassische Führungen</b><br>Montag bis Freitag<br>9:00–12:00 / 14:00–17:00<br><br><b>Magische Tour</b><br>Zweimal im Monat, montags, nach Vereinbarung.<br><br>Da die Parkplätze begrenzt sind, empfehlen wir Ihnen, die öffentlichen Verkehrsmittel zu benutzen. Die Cinémathèque suisse befindet sich 15 Gehminuten vom Bahnhof Cossonay-Penthalaz entfernt.',
        text4: {
            option1: 'Am Morgen',
            option2: 'Am Nachmittag',
        }
    },
    formVisitBooking3: {
        text1: 'Informationen zu den Besuchenden',
        text2: 'Kurze Beschreibung der Gruppe',
    },
    formVisitBooking4: {
        text1: 'Anzahl Personen (maximal 30)',
        text2: 'Anzahl',
        text3: 'Altersgruppe',
        text4: {
            option1: '7–11 Jahre',
            option2: '12–15 Jahre',
            option3: '15–18 Jahre',
            option4: 'Alle',
        },
        text5: 'Haben Sie für Ihren Besuch bestimmte Erwartungen oder Wünsche?',
        text6: 'Beschreibung',
        text7: 'Besondere Bedürfnisse',
        text8: {
            option1: 'Tour mit regelmässigen Sitzgelegenheiten',
            option2: 'Tour ohne Treppen',
        },
    },
    formVisitBooking5: {
        text1: 'Bemerkungen',
        text2: 'Haben Sie noch Anmerkungen zu Ihrer Anfrage?',
    },
    formVisitBooking6: {
        text1: 'Anfrage senden',
    },
    formFilmScreening: {
        text1: 'An einer Vorführung teilnehmen – Gruppe',
    },
    formFilmScreening1: {
        text1: 'Anzahl Personen (mindestens 10) *',
        text2: 'Anzahl',
        text3: 'Gesellschaft / Unternehmen / Privat',
        text4: 'Name des Unternehmens / der Einrichtung',
        text5: 'Gruppenreservierungen sind nur ausserhalb von Sonderveranstaltungen und Vorpremieren ab 10 Personen möglich.<br><br>Nach Erhalt einer Reservationsbestätigung können Sie Ihre Tickets während der Öffnungszeiten oder bis spätestens 10 Minuten vor der Vorstellung direkt an der Kinokasse abholen und bezahlen. Danach können wir Ihre Reservation leider nicht mehr garantieren und Ihre Plätze werden wieder zum Verkauf angeboten.',
    },
    formFilmScreening2: {
        text1: 'Gewünschtes Datum der Vorführung',
        text2: 'Gewünschte Uhrzeit der Vorführung',
        text3: 'Das Kinoprogramm finden Sie auf <br><a href="https://www.cinematheque.ch/" target="_blank">www.cinematheque.ch</a>.',
    },
    formFilmScreening3: {
        text1: 'Bemerkungen',
        text2: 'Haben Sie noch Anmerkungen zu Ihrer Anfrage?',
    },
    formFilmScreening4: {
        text1: 'Anfrage senden',
    },
    formSchoolFilmScreening: {
        text1: 'An einer Vorführung teilnehmen – Schulklasse',
    },
    formSchoolFilmScreening1: {
        text1: 'Schulische Einrichtung *',
        text2: 'Name der Schule',
        text3: 'Anzahl Schüler:innen *',
        text4: 'Anzahl',
        text5: 'Anzahl Begleitpersonen *',
        text6: 'Anzahl',
        text7: 'Kanton *',
        text8: 'Altersgruppe',
        text9: {
            option1: '7–11 Jahre',
            option2: '12–15 Jahre',
            option3: '15–18 Jahre',
            option4: 'über 18 Jahre',
        },
        text10: 'Bei Sonderveranstaltungen und Vorpremieren können keine Reservierungen für Schulklassen gemacht werden.<br><br>Nach Erhalt einer Reservationsbestätigung können Sie Ihre Tickets während der Öffnungszeiten oder bis spätestens 10 Minuten vor der Vorstellung direkt an der Kinokasse abholen und bezahlen. Danach können wir Ihre Reservation leider nicht mehr garantieren und Ihre Plätze werden wieder zum Verkauf angeboten.<br><br>Um den Ablauf an der Kasse zu beschleunigen, bringen Sie bitte eine ausgedruckte Liste mit den Namen der Schüler:innen und Begleitpersonen mit, die an der Vorführung teilnehmen.',
    },
    formSchoolFilmScreening2: {
        text1: 'Gewünschtes Datum der Vorführung *',
        text2: 'Gewünschte Uhrzeit der Vorführung *',
        text3: 'Das Kinoprogramm finden Sie auf <br><a href="https://www.cinematheque.ch/" target="_blank">www.cinematheque.ch</a>.',
    },
    formSchoolFilmScreening3: {
        text1: 'Bemerkungen',
        text2: 'Haben Sie noch Anmerkungen zu Ihrer Anfrage?',
    },
    formSchoolFilmScreening4: {
        text1: 'Anfrage senden',
    },
    formMaterialDeposit: {
        text1: 'Material hinterlegen oder abliefern',
        conditions: "Das Material entspricht den <a href=\"".concat(getUrl(urls.docs.d12, DE), "\" target=\"_blank\">\uD83D\uDDCEtechnischen Vorgaben f\u00FCr die obligatorische Hinterlegung digitaler Filmelemente</a> (italienische Fassung <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhier</a> verf\u00FCgbar)"),
    },
    formMaterialDeposit1: {
        text1: 'Titel der Anfrage',
        text2: 'Titel Ihrer Anfrage',
        text3: 'Details zur Anfrage',
        text4: 'Grund für das Angebot einer Ablieferung',
        text5: "Die Cin\u00E9math\u00E8que suisse wird Ihre Anfrage nach Erhalt m\u00F6glichst schnell pr\u00FCfen und mit Ihnen Kontakt aufnehmen. Der Entscheid \u00FCber die Annahme einer Schenkung oder Hinterlegung wird auf der Grundlage der <a href=\"".concat(getUrl(urls.docs.d09, DE), "\" target=\"_blank\">\uD83D\uDDCESammlungspolitik</a> und der <a href=\"").concat(getUrl(urls.docs.d10, DE), "\" target=\"_blank\">\uD83D\uDDCEBedingungen f\u00FCr die Hinterlegung digitaler Best\u00E4nde</a> getroffen. Es kann deshalb vorkommen, dass eine Schenkung oder Hinterlegung ganz oder teilweise abgelehnt werden muss."),
    },
    formMaterialDeposit2: {
        text1: 'Art der Ablieferung',
        text2: {
            option1: 'Hinterlegung/Depot',
            option2: 'Schenkung',
        },
        text3: 'Können Sie ein Inventar für die betreffende Ablieferung vorlegen?',
        text4: {
            option1: 'Ja',
            option2: 'Nein',
        },
        text5: 'Bei einer Schenkung gehen die Eigentumsrechte an den Dokumenten und Objekten an die Cinémathèque suisse über.',
    },
    formMaterialDeposit3: {
        text1: 'Arten von Objekten im Rahmen der Ablieferung',
        text2: {
            option1: 'Filme: Material auf Film, digitale Dateien, Datenträger etc.',
            option2: 'Bildmaterial: Fotografien, Plakate etc.',
            option3: 'Kinematografische Apparate',
            option4: 'Papierarchive',
        },
        text3: 'Details',
        text4: 'Trägerarten, Titel der Werke, Regisseur:in, Produktionsjahr, Rechteinhaber, Provenienz, verfügbare Dokumentation etc.',
        text5: 'Beschreibung des Bildmaterials',
        text6: 'Beschreibung von Filmapparaten',
        text7: 'Ungefähres Volumen',
        text8: 'Bitte geben Sie eine Schätzung in Kubikmeter, Kilogramm und/oder die Anzahl Europaletten an.',
        text9: 'Die Cinémathèque suisse behält sich das Recht vor, eine erste Auswahl zu treffen, indem sie Elemente, die unbrauchbar, zu schlecht erhalten sind und/oder eine Gefahr für die Sammlung darstellen, aussortiert.',
    },
    formMaterialDeposit4: {
        text1: 'Bemerkungen',
        text2: 'Haben Sie noch Anmerkungen zu Ihrer Anfrage?',
    },
    formMaterialDeposit5: {
        text1: 'Anfrage senden',
    },
    formMaterialDeposit6: {
        text1: "<b>Bitte übermitteln Sie kein Material an die Cinémathèque suisse, bis wir Ihr Angebot bestätigt haben. </b>",
    },
    formVisitBookingZh: {
        text1: "Besuch des Archivierungszentrums in Zürich",
    },
    formVisitBookingZh1: {
        text1: 'Gewünschtes Datum des Besuchs *',
        text2: 'Gewünschte Zeit',
        text3: {
            option1: 'Am Morgen',
            option2: 'Am Nachmittag',
        },
        text4: 'Mindestfrist von 1 Woche zwischen der Anfrage und dem gewünschten Termin.<br><br><b>Forschungs- und Archivierungszentrum<br>Neugasse 10<br>CH-8005 Zürich</b><br><br><b>Besuchszeiten</b><br>Montag bis Donnerstag<br>9:00 - 12:30 / 13:30 - 17:00<br><br>Freitag geschlossen',
    },
    formVisitBookingZh2: {
        text1: 'Anzahl Personen *',
        text2: 'Anzahl',
        text3: 'Informationen zu den Besuchenden',
        text4: 'Kurze Beschreibung der Gruppe',
    },
    formVisitBookingZh3: {
        text1: 'Haben Sie für Ihren Besuch bestimmte Erwartungen oder Wünsche?',
        text2: 'Beschreibung',
    },
    formVisitBookingZh4: {
        text1: 'Bemerkungen',
        text2: 'Haben Sie noch Anmerkungen zu Ihrer Anfrage?',
    },
    formVisitBookingZh5: {
        text1: 'Anfrage senden',
    },
    forms: {
        'projection-copy': 'Bestellung einer Vorführkopie',
        'clip-request': 'Bestellung von Filmauszügen',
        'viewing-request': 'Visionierungsanfrage',
        'release-order': 'Freigabeauftrag',
        'material-access': 'Zugang zu Material',
        'cine-journal': 'Lizenz und Videomaterial der Schweizer Filmwochenschau',
        'on-site-consultation': 'Anfrage zur Einsichtnahme vor Ort',
        'still-images': 'Bestellung von Standbildern',
        'promotional-material': 'Vertrieb – Bestellung von Promotionsmaterial',
        'film-screening': 'An einer Vorführung teilnehmen – Gruppe',
        'school-film-screening': 'An einer Vorführung teilnehmen – Schulklasse',
        'partnership-request': 'Partnerschaftsantrag',
        'room-rental': 'Mietanfrage',
        'room-rental-film': 'Mietanfrage mit Ausleihe einer Filmkopie',
        'visit-booking': 'Besuch des Archivierungszentrums in Penthaz',
        'visit-booking-zh': 'Besuch des Archivierungszentrums in Zürich',
        'information-request': 'Anfrage nach Informationen zu den Sammlungen',
        'material-deposit': 'Material hinterlegen oder abliefern',
    },
    formList: {
        title: 'Liste der Formulare',
        callToAction: 'Klicken Sie auf das Formular für Ihre Anfrage:',
        headers: {
            section1: 'Filmsammlungen',
            section2: 'Non-Filmsammlungen',
            section3: 'Kulturvermittlung',
            section4: 'Allgemeine Ressourcen',
        },
        section1: {
            link1: 'Bestellung einer Vorführkopie',
            link2: 'Bestellung von Filmauszügen',
            link3: 'Visionierungsanfrage',
            link4: 'Freigabeauftrag',
            link5: 'Zugang zu Material',
            link6: 'Lizenz und Videomaterial der Schweizer Filmwochenschau',
        },
        section2: {
            link1: 'Anfrage zur Einsichtnahme vor Ort',
            link2: 'Bestellung von Standbildern',
            link3: 'Vertrieb – Bestellung von Promotionsmaterial',
        },
        section3: {
            link1: 'An einer Vorführung teilnehmen – Gruppe',
            link2: 'An einer Vorführung teilnehmen – Schulklasse',
            link3: 'Partnerschaftsantrag',
            link4: 'Mietanfrage',
            link5: 'Mietanfrage mit Ausleihe einer Filmkopie',
            link6: 'Besuch des Archivierungszentrums in Penthaz',
            link7: 'Besuch des Archivierungszentrums in Zurich',
        },
        section4: {
            link1: "Anfrage nach Informationen zu den Sammlungen",
            link2: "Material hinterlegen oder abliefern",
        },
    },
    visits: {
        visit1: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_2fd94e_1191404542.jpg',
            p1: '<b>Klassische Führung (für jedes Publikum)</b><br>Frequenz: 2 Mal im Monat',
            p2: 'Die klassische Führung ist für ein breites Publikum gedacht und bietet einen Überblick über die Arbeit und die Aufgaben der Cinémathèque suisse. Nach einer kurzen Filmvorführung erläutern Mitarbeitende die verschiedenen Herausforderungen im Zusammenhang mit der Konservierung und Restaurierung. Darauf folgt ein etwa zweistündiger Rundgang durch die Räumlichkeiten.',
        },
        visit2: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_e7861e_7c4a4769b5.jpg',
            p1: '<b>Magische Tour (für 7- bis 11-Jährige)</b><br>Frequenz: 2 Mal im Monat, an einem Montag (TBC)',
            p2: 'Dieser eineinhalbstündige Besuch bietet eine spielerische Einführung in die Welt der Archive und gibt Kindern einen Einblick in die Aufgaben der Cinémathèque suisse und die Arbeit, die von ihren Mitarbeitenden geleistet wird (Konservierung, Restaurierung etc.). Auf dem Programm stehen Momente des Austauschs, eine kurze Filmvorführung sowie Workshops rund um die frühe Kinogeschichte und den Animationsfilm.',
        },
    },
    rooms: {
        room1: {
            img: 'https://www.cinematheque.ch/sites/default/files/2022-12/Cin%C3%A9matographe_Salle%20de%20projection_Casino%20de%20Montbenon.jpg',
            p1: '<b>Technische Informationen zum Cinématographe</b><br>Stand: 1. Mai 2017',
            p2: 'Anzahl Sitzplätze: 101<br>Raumgrösse: 13 m × 6 m',
            p3: '<b>Leinwand</b><br>Grösse: 4,65 m × 2,13 m',
            p4: '<b>Projektoren</b><br>35-mm-Projektor: 2 Cinemeccanica Victoria<br>16-mm-Projektor: 1 Prevost Doppelband<br>Videoprojektor: 1 Barco DP4K-32B',
            p5: '<b>Wiedergabematerial</b><br>Beta-Player: 1 SONY Betacam J-30 (SP, SX, Digital, MPEG IMX) (5 Analog, 5 BNC)<br>Blu-Ray-Player: 1 OPPO Blu-Ray BDP-103 (USB-Sticks, MPEG4, H264, Bitrate max. 50 Mbps)<br>DVCAM+MiniDV-Player: 1 SONY DVCAM+MiniDV (HDV 1080i, HDMI Prog, DV)<br>(60i, 30p, 24p, 30i, 25p)<br>Server: 1 Doremi DCP-2000',
            p6: '<b>Ton und Sonstiges</b><br>DOLBY CP650 (Dolby 5.1)<br>JPA-Verstärker (Schleife für Hörbehinderte), 3 drahtlose Mikrofone (Sennheiser),<br>2 drahtgebundene Mikrofone (Sennheiser), 1 Tischmikrofon (JTS)',
            p7: '<b>Instrumente</b><br>1 Klavier (Sauter)',
            p8: '<b>Anschlüsse auf der Bühne</b><br>1 HDMI- und VGA-Anschlusshub und 6 XLR-Anschlüsse<br>1 RJ45-Anschluss (Internetverbindung)',
            p9: '<b>Barrierefreiheit</b><br>Zugang zum Saal: Platz für 1 Rollstuhl (auf Anmeldung)<br>Zugang zum WC: ja',
        },
    },
    customerProfileShow: {
        text1: 'Benutzerkonto',
    },
    customerProfileShow1: {
        text1: "Benutzername",
        text2: 'E-Mail',
        text3: {
            label: 'FIAF-Status',
            status1: 'FIAF-Mitglied',
            status2: 'Nichtmitglied ',
        },
        text4: 'Telefon',
        text5: 'Lieferadresse',
        text6: 'Rechnungsangaben',
        deliveryAddress: {
            text1: 'Land',
            text2: 'Stadt',
            text3: 'Strasse',
            text4: 'Unternehmen',
        },
        billingAddress: {
            text1: 'Land',
            text2: 'Stadt',
            text3: 'Strasse',
            text4: 'Unternehmen',
        }
    },
    customerProfileShow2: {
        text1: "Meine E-Mail-Adresse / Passwort bearbeiten",
    },
    cantons: {
        AG: 'Aargau',
        AI: 'Appenzell I.Rh.',
        AR: 'Appenzell A.Rh.',
        BE: 'Bern',
        BL: 'Basel-Landschaft',
        BS: 'Basel-Stadt',
        FR: 'Freiburg',
        GE: 'Genf',
        GL: 'Glarus',
        GR: 'Graubünden',
        JU: 'Jura',
        LU: 'Luzern',
        NE: 'Neuenburg',
        NW: 'Nidwalden',
        OW: 'Obwalden',
        SG: 'Sankt Gallen',
        SH: 'Schaffhausen',
        SO: 'Solothurn',
        SZ: 'Schwyz',
        TG: 'Thurgau',
        TI: 'Tessin',
        UR: 'Uri',
        VD: 'Waadt',
        VS: 'Wallis',
        ZG: 'Zoug',
        ZH: 'Zürich',
    },
    countries: {
        AF: 'Afghanistan',
        AL: 'Albanien',
        DZ: 'Algerien',
        AS: 'Amerikanisch-Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktis',
        AG: 'Antigua und Barbuda',
        AR: 'Argentinien',
        AM: 'Armenien',
        AW: 'Aruba',
        AU: 'Australien',
        AT: 'Österreich',
        AZ: 'Aserbaidschan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesch',
        BB: 'Barbade',
        BY: 'Biélorussie',
        BE: 'Belgique',
        BZ: 'Belize',
        BJ: 'Bénin',
        BM: 'Bermudes',
        BT: 'Bhoutan',
        BO: 'Bolivie',
        BA: 'Bosnie-Herzégovine',
        BW: 'Botswana',
        BV: 'Île Bouvet',
        BR: 'Brésil',
        IO: 'Océan Indien Britannique',
        BN: 'Brunei Darussalam',
        BG: 'Bulgarie',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodge',
        CM: 'Cameroun',
        CA: 'Canada',
        CV: 'Cap-Vert',
        KY: 'Îles Caïmans',
        CF: 'République Centrafricaine',
        TD: 'Tchad',
        CL: 'Chili',
        CN: 'Chine',
        CX: 'Île Christmas',
        CC: 'Îles Cocos',
        CO: 'Colombie',
        KM: 'Comores',
        CG: 'République du Congo',
        CD: 'République démocratique du Congo',
        CK: 'Îles Cook',
        CR: 'Costa Rica',
        CI: 'Côte-d’Ivoire',
        HR: 'Croatie',
        CU: 'Cuba',
        CY: 'Chypre',
        CZ: 'République Tchèque',
        DK: 'Danemark',
        DJ: 'Djibouti',
        DM: 'Dominique',
        DO: 'République Dominicaine',
        EC: 'Équateur',
        EG: 'Égypte',
        SV: 'El Salvador',
        GQ: 'Guinée équatoriale',
        ER: 'Érythrée',
        EE: 'Estonie',
        ET: 'Éthiopie',
        FK: 'Îles Malouines',
        FO: 'Îles Féroé',
        FJ: 'Fidji',
        FI: 'Finlande',
        FR: 'France',
        GF: 'Guyane française',
        PF: 'Polynésie française',
        TF: 'Terres australes françaises',
        GA: 'Gabon',
        GM: 'Gambie',
        GE: 'Géorgie',
        DE: 'Allemagne',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Grèce',
        GL: 'Groenland',
        GD: 'Grenade',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GN: 'Guinée',
        GW: 'Guinée-Bissau',
        GY: 'Guyana',
        HT: 'Haïti',
        HM: 'Îles Heard-et-MacDonald',
        VA: 'Saint-Siège (Vatican)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hongrie',
        IS: 'Islande',
        IN: 'Inde',
        ID: 'Indonésie',
        IR: 'Iran',
        IQ: 'Irak',
        IE: 'Irlande',
        IL: 'Israël',
        IT: 'Italie',
        JM: 'Jamaïque',
        JP: 'Japon',
        JO: 'Jordanie',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'Corée du Nord',
        KR: 'Corée du Sud',
        KW: 'Koweït',
        KG: 'Kirghizistan',
        LA: 'Laos',
        LV: 'Lettonie',
        LB: 'Liban',
        LS: 'Lesotho',
        LR: 'Libéria',
        LY: 'Libye',
        LI: 'Liechtenstein',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'Macédoine du Nord',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaisie',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malte',
        MH: 'Îles Marshall',
        MQ: 'Martinique',
        MR: 'Mauritanie',
        MU: 'Maurice',
        YT: 'Mayotte',
        MX: 'Mexique',
        FM: 'Micronésie',
        MD: 'Moldavie',
        MC: 'Monaco',
        MN: 'Mongolie',
        MS: 'Montserrat',
        MA: 'Maroc',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibie',
        NR: 'Nauru',
        NP: 'Népal',
        NL: 'Pays-Bas',
        NC: 'Nouvelle-Calédonie',
        NZ: 'Nouvelle-Zélande',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigéria',
        NU: 'Niué',
        NF: 'Île Norfolk',
        MP: 'Îles Mariannes du Nord',
        NO: 'Norvège',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palaos',
        PS: 'Palestine',
        PA: 'Panama',
        PG: 'Papouasie-Nouvelle-Guinée',
        PY: 'Paraguay',
        PE: 'Pérou',
        PH: 'Philippines',
        PN: 'Îles Pitcairn',
        PL: 'Pologne',
        PT: 'Portugal',
        PR: 'Porto Rico',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Roumanie',
        RU: 'Russie',
        RW: 'Rwanda',
        SH: 'Sainte-Hélène',
        KN: 'Saint-Christophe-et-Niévès',
        LC: 'Sainte-Lucie',
        PM: 'Saint-Pierre-et-Miquelon',
        VC: 'Saint-Vincent-et-les-Grenadines',
        WS: 'Samoa',
        SM: 'Saint-Marin',
        ST: 'São Tomé-et-Principe',
        SA: 'Arabie Saoudite',
        SN: 'Sénégal',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapour',
        SK: 'Slovaquie',
        SI: 'Slovénie',
        SB: 'Îles Salomon',
        SO: 'Somalie',
        ZA: 'Afrique du Sud',
        GS: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
        ES: 'Espagne',
        LK: 'Sri Lanka',
        SD: 'Soudan',
        SR: 'Suriname',
        SJ: 'Svalbard et Île Jan Mayen',
        SZ: 'Royaume d’Eswatini',
        SE: 'Suède',
        CH: 'Suisse',
        SY: 'Syrie',
        TW: 'Taïwan',
        TJ: 'Tadjikistan',
        TZ: 'République unie de Tanzanie',
        TH: 'Thaïlande',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinité-et-Tobago',
        TN: 'Tunisie',
        TR: 'Turquie',
        TM: 'Turkménistan',
        TC: 'Îles Turques-et-Caïques',
        TV: 'Tuvalu',
        UG: 'Ouganda',
        UA: 'Ukraine',
        AE: 'Émirats Arabes Unis',
        GB: 'Royaume-Uni',
        US: 'États-Unis d’Amérique',
        UM: 'Îles mineures éloignées des États-Unis',
        UY: 'Uruguay',
        UZ: 'Ouzbékistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'Îles vierges britanniques',
        VI: 'Îles vierges américaines',
        WF: 'Wallis-et-Futuna',
        EH: 'Sahara occidental',
        YE: 'Yémen',
        ZM: 'Zambie',
        ZW: 'Zimbabwe',
        AX: 'Åland',
        BQ: 'Bonaire, Saint-Eustache et Saba',
        CW: 'Curaçao',
        GG: 'Guernesey',
        IM: 'Île de Man',
        JE: 'Jersey',
        ME: 'Monténégro',
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin (partie française)',
        RS: 'Serbie',
        SX: 'Saint-Martin (partie néerlandaise)',
        SS: 'Soudan du Sud',
        XK: 'Kosovo',
    },
    validation: __assign({ startBeforeEnd: "Das Datum der ersten Vorführung liegt nach dem Datum der letzten Vorführung.", initialDateDelay: "Die Vorlaufzeit wird nicht eingehalten.", disallowWeekend: "Samstag und Sonntag können nicht ausgewählt werden.", any: "Bitte wählen Sie mindestens eine Kategorie aus.", checked: "" }, (de.messages))
};
